import { FC } from 'react';
import { DetailsBooking, Money } from 'types';
import { getDiscountVoucherAmount, getPendingScheduledPayment } from 'lib/bookingInfo';
import ChargesSummaryComponent, { ChargesSummaryProps } from 'components/ChargesSummary';
import DownloadInvoiceButton from './DownloadInvoiceButton';

const ChargeSummary: FC<{ booking: DetailsBooking }> = ({ booking }) => {
  const props: ChargesSummaryProps = {
    isCancelled: booking.flags.isCancelled,
    nights: booking.nights,
    baseAmount: booking.payableAtBooking as Money,
    discountAmount: getDiscountVoucherAmount(booking),
    offerTotalAmounts: booking.payableTotals as Array<Money>,
    formattedCheckIn: booking.reservation.formattedCheckIn,
    payableAtPropertyTotal: booking.payableAtProperty ? (booking.payableAtProperty.total as Money) : undefined,
    payableAtPropertyBreakdown: booking.payableAtProperty
      ? booking.payableAtProperty.breakdown.map((item) => ({
          description: item.description,
          charge: item.charge as Money,
        }))
      : undefined,
    paidToDateAmounts: booking.paidBeforeCancellation.totals as Array<Money>,
    pendingScheduledPayment: getPendingScheduledPayment(booking),
    ActionComponent: <DownloadInvoiceButton booking={booking} />,
  };

  return <ChargesSummaryComponent {...props} />;
};

export default ChargeSummary;
